import { motion } from "framer-motion";

/**
 * PuzzleMark — official Krister Overseas puzzle icon mark.
 * The image is the real brand mark (puzzle icons only — no wordmark).
 * "KRISTER OVERSEAS" is set in Montserrat alongside this mark in lockups.
 *
 * The puzzle mark renders cleanly on both dark and cream backgrounds:
 * white puzzle pieces with crisp black icons (cup, diary, trophy, umbrella).
 */
export const PuzzleMark = ({ size = 48, animated = true }) => {
  const Img = (
    <img
      src="/brand/puzzle-mark.png"
      alt="Krister Overseas"
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        display: "block",
        objectFit: "contain",
      }}
    />
  );

  if (!animated) return Img;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      style={{ width: size, height: size }}
    >
      {Img}
    </motion.div>
  );
};

export default PuzzleMark;
